import api from './api';

const permissionService = {
  // Create a new permission
  createPermission: async (permissionData) => {
    const response = await api.post('/permissions', permissionData);
    return response.data;
  },

  // Get permissions for a user
  getPermissionsByUserId: async (userId) => {
    const response = await api.get(`/permissions?userid=${userId}`);
    return response.data;
  },

  // Update a permission
  updatePermission: async (id, permissionData) => {
    const response = await api.put(`/permissions/${id}`, permissionData);
    return response.data;
  },

  // Delete a permission
  deletePermission: async (id) => {
    const response = await api.delete(`/permissions/${id}`);
    return response.data;
  },

  // Get all chains the current logged-in user has any permission on
  getMyChains: async () => {
    const response = await api.get('/permissions?myChains=1');
    return response.data;
  },

  // Check if the current logged-in user is a chain admin for the given account
  checkChainAdmin: async (accountId) => {
    const response = await api.get(`/permissions?checkAdmin=1&accountId=${accountId}`);
    return response.data;
  },

  // Check if the current logged-in user is admin on any hotel or chain
  checkAnyAdmin: async () => {
    const response = await api.get('/permissions?checkAnyAdmin=1');
    return response.data;
  }
};

export default permissionService;
